<template>
  <div>
    <h1>Mental Auth</h1>
  </div>
</template>

<script>
import { post } from '@/utils/ajax'
export default {
  name: 'MentalAuth',
  mounted () {
    this.getMentalAuth()
  },
  methods: {
    async getMentalAuth () {
      const token = this.$route.query.token
      if (!token) {
        return
      }
      const params = {
        agreementIds: [-1],
        token,
        pid: 'h27qydlS'
      }
      try {
        if (this.$store.state.hasToken) {
          await this.$auth('logout')
        }
        const res = await post(`${window.CONFIG.api_backend}/tiger/v3/web/accounts/oauth/xlx`, params)
        if (res.auth && res.auth.token) {
          const userInfo = await this.$auth('get_profile')
          this.$store.commit('SET_USER', userInfo)
          this.$store.commit('HAS_TOKEN', true)
          window.parent.postMessage({
            type: 'mental-auth-success',
            data: userInfo
          }, window.CONFIG.xinli_origin)
        } else {
          window.parent.postMessage({
            type: 'mental-auth-error',
            data: '登录态失效，请重新登录'
          }, window.CONFIG.xinli_origin)
        }
      } catch (error) {
        console.error(error)
        window.parent.postMessage({
          type: 'mental-auth-error',
          data: '登录态失效，请重新登录'
        }, window.CONFIG.xinli_origin)
      }
    }
  },
}
</script>
